import { Text } from "@chakra-ui/react";
import { formatDistanceToNow } from "date-fns";
import React from "react";
import { Column } from "react-table";
import {
  formatDateForSummary,
  formatDateMDY,
} from "../../lib/number-transforms";

export const allTableColumns: Column<any>[] = [
  {
    Header: "Name",
    accessor: "name",
    width: "30%",
    sortType: (a, b, id) => {
      const valueA = a.values[id].toLowerCase();
      const valueB = b.values[id].toLowerCase();
      return valueB > valueA ? 1 : valueB < valueA ? -1 : 0;
    },
    Cell: ({ cell }) => {
      return (
        <Text maxWidth="350px" isTruncated title={cell.value}>
          {cell.value}
        </Text>
      );
    },
  },
  {
    Header: "Quote Type",
    accessor: "quoteTypeLabel",
    width: "15%",
  },
  {
    Header: "Product",
    accessor: "productType",
    width: "15%",
  },
  // {
  //   Header: "Underwriter",
  //   accessor: "underwriterStatus",
  //   width: "15%",
  // },
  {
    Header: "Created On",
    accessor: "createdOn",
    sortDescFirst: true,
    Cell: ({ cell }) => {
      return formatDateMDY(cell.value);
    },
    width: "15%",
  },
  {
    Header: "Owned By",
    accessor: "createdBy",
    width: "15%",
  },
  {
    Header: "Last Updated",
    accessor: "modifiedOn",
    sortDescFirst: true,
    Cell: ({ cell }) => {
      return formatDistanceToNow(
        new Date(
          formatDateForSummary(cell.value.substring(0, cell.value.length - 1))
        ),
        {
          addSuffix: true,
        }
      );
    },
    width: "15%",
  },
];
